export enum ChatsApiTags {
  pin = "pin",
  getMessages = "getMessages",
}
